/**
 * Ordena notificações pela data de criação (mais recentes primeiro).
 *
 * @param {Array<{ createdAt?: string|null }>} [notifications]
 * @returns {Array}
 */
export function sortNotificationsByCreatedAtDesc(notifications) {
  if (!Array.isArray(notifications)) return [];

  return [...notifications].sort((a, b) => {
    const aTime = Date.parse(a?.createdAt || "") || 0;
    const bTime = Date.parse(b?.createdAt || "") || 0;
    return bTime - aTime;
  });
}
